<template>
  <div class="addMain wraper">
    <template>
      <el-backtop target=".wraper"></el-backtop>
    </template>
     <div class="returnBtn" @click="goBack()">
        <i class="el-icon-back"></i>
      </div>
        <el-breadcrumb class="crumbs" separator-class="el-icon-arrow-right">
       <el-breadcrumb-item v-for="(item,index)  in routeList" 
       :key="index"
      :to="{ name: item.name,query:{id:item.query.id,flag:item.query.flag,name:item.query.name} }">
      {{item.name}}
        </el-breadcrumb-item>
    </el-breadcrumb>
    <el-card shadow="never">
      <div class="cardTop">
        <h1 v-if="flag != 'edit'">创建萤石云账号</h1>
        <h1 v-if="flag == 'edit'">更新萤石云账号</h1>
      </div>
      <div class="cardBottom">
        <div class="addIntroduce">
          <h3 v-if="flag != 'edit'">填写萤石云账号的信息。</h3>
          <h3 v-if="flag == 'edit'">更新萤石云账号的信息。</h3>
        </div>
        <el-form ref="addForm" :model="addForm" :rules="rules">
          <el-form-item label="账号" prop="account"
            ><br />
            <div class="subheading">输入萤石云账号。</div>
            <el-input v-model="addForm.account" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="AppKey" prop="appKey"
            ><br />
            <el-input v-model="addForm.appKey" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="AppSecret" prop="appSecret"
            ><br />
            <el-input v-model="addForm.appSecret" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="accessToken" prop="accessToken"
            ><br />
            <el-input v-model="addForm.accessToken" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="过期时间" prop="expireTimeStr"
            ><br />
            <el-date-picker
              v-model="addForm.expireTimeStr"
              type="datetime"
              placeholder="选择日期时间"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="备注" prop="remarks"
            ><br />
            <el-input v-model="addForm.remarks" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="text" @click="$router.history.go(-1)"
              >取消</el-button
            >
            <el-button
              v-if="flag != 'edit'"
              type="primary"
              @click="onSubmit('addForm')"
              >创建萤石云账号</el-button
            >
            <el-button
              v-if="flag == 'edit'"
              type="primary"
              @click="editOnSubmit('addForm')"
              >更新萤石云账号</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>
<script>
import API from "../../api/api";
import dayjs from "dayjs"
export default {
  data() {
    return {
      routeList:this.$route.meta.routeList,
      flag: this.$route.query.flag,
      rules: {
        account: [{ required: true, message: "请输入萤石云账号", trigger: "blur" }],
        appKey: [{ required: true, message: "请输入appKey", trigger: "blur" }],
        appSecret: [{ required: true, message: "请输入appSecret", trigger: "blur" }],
        accessToken: [{ required: true, message: "请输入accessToken", trigger: "blur" }],
        expireTimeStr: [{ required: true, message: "请选择过期时间", trigger: "blur" }],
      },
      addForm: {
        id: '',
        account: '',
        appKey: '',
        appSecret: '',
        accessToken: '',
        expireTimeStr: '',
        remarks: '',
      },
    };
  },
  created() {},
  methods: {
    //当页面为编辑状态flag==edit时要获取到当前编辑的信息
    getMage() {
      if (this.flag == "edit") {
        let id = this.$route.query.id;
        API.ysAccountGetById({id}).then(res => {
          if (res.code == 1) {
            res.data.expireTimeStr = dayjs(new Date(res.data.expireTime)).format("YYYY-MM-DD HH:mm:ss");
            this.addForm = res.data;
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        return false;
      }
    },
    //创建设备
    onSubmit(formName) {
      let _this = this;
      let _API = API;
      this.$refs[formName].validate(valid => {
        if (valid) {
          _API.ysAccountSave(_this.addForm).then(res => {
            if (res.code == 1) {
              _this.$message({
                message: "创建萤石云账号成功",
                type: "success"
              });
              _this.$router.push({
                path: "/ysManager/ysAccountList"
              });
            } else {
              _this.$message({
                message: res.msg,
                type: "error"
              });
            }
          });
        } else {
          _this.$message({
            message: "请填写完所有必填项",
            type: "error"
          });
          return false;
        }
      });
    },
    //更新设备
    editOnSubmit(formName) {
      let _this = this;
      let _API = API;
      this.$refs[formName].validate(valid => {
        if (valid) {
          delete _this.addForm.createDate
          delete _this.addForm.updateDate
          delete _this.addForm.expireTime
          delete _this.addForm.status
          _API.ysAccountSave(_this.addForm)
            .then(res => {
              if (res.code == 1) {
                _this.$message({
                  message: "更新萤石云账号成功",
                  type: "success"
                });
                _this.$router.push({
                  path: "/ysManager/ysAccountList"
                });
              } else {
                _this.$message({
                  message: res.msg,
                  type: "error"
                });
              }
            });
        } else {
          _this.$message({
            message: "请填写完所有必填项",
            type: "error"
          });
          return false;
        }
      });
    }
  },
  mounted() {
    this.getMage();
  }
};
</script>



// WEBPACK FOOTER //
// src/views/platform/ysAccountAdd.vue